<template>
  <section
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? vars.textColor : 'var(--c-text-primary)'}`"
  >
    <div v-if="variants.GoogleReviews === variant" class="tw-w-full tw-text-center">
      <h3 class="tw-pt-14">{{ vars.titleText }}</h3>
      <div class="tw-flex tw-h-full tw-w-full tw-flex-col tw-items-center tw-gap-10 tw-py-14">
        <Swiper
          :modules="[SwiperPagination]"
          :pagination="true"
          :slides-per-view="1"
          :space-between="30"
          effect="fade"
          :clickable="true"
          :loop="true"
          :breakpoints="{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1336: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }"
          class="tw-w-full tw-max-w-lg lg:tw-max-w-full"
        >
          <SwiperSlide v-for="(review, index) in reviews" :key="index">
            <div
              class="tw-flex tw-h-full tw-min-h-[400px] tw-flex-col tw-gap-3 tw-rounded-lg tw-border-2 tw-p-10 tw-text-start"
            >
              <div class="tw-flex tw-items-center tw-gap-2">
                <svg
                  v-for="n in review.evaluation_value"
                  :key="n"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                    fill="#aead66"
                  />
                </svg>
              </div>
              <h6>{{ review.person_name }}</h6>
              <span class="tw-font-bold">{{ review.date }}</span>
              <p class="tw-max-h-64 tw-overflow-y-auto tw-pt-4 lg:tw-max-h-56">{{ review.content }}</p>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
    <div
      v-if="variants.GoogleReviewsV2 === variant"
      class="tw-flex tw-w-full tw-flex-col tw-items-center tw-text-center"
    >
      <h2 v-if="vars.titleText" class="tw-pt-14">{{ vars.titleText }}</h2>
      <div v-if="vars.titleHtml" v-html="vars.titleHtml" class="tw-pt-14"></div>
      <div
        class="tw-relative tw-flex tw-h-full tw-w-full tw-max-w-lg tw-flex-col tw-items-center tw-gap-10 tw-py-14 lg:tw-max-w-full"
      >
        <div class="content-container">
          <MotionGroup
            :preset="vars.animationText ? vars.animationText : 'slideVisibleBottom'"
            :duration="700"
            is="div"
          >
            <div class="swiper-wrapper">
              <Swiper
                :modules="[SwiperPagination]"
                @slideChange="onSlideChange"
                @swiper="onSwiper"
                :slides-per-view="1"
                :space-between="30"
                :loop="true"
                effect="fade"
                :clickable="true"
                :breakpoints="{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  1024: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                  },
                  1336: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                }"
                class="tw-w-full"
              >
                <SwiperSlide v-for="(review, index) in reviews" :key="index">
                  <div
                    class="n-testimonial-card tw-flex tw-h-full tw-min-h-[400px] tw-flex-col tw-gap-3 tw-p-10 tw-text-start"
                    style="border-radius: var(--rounded); border: 1px solid var(--c-border)"
                  >
                    <div class="tw-flex tw-justify-between">
                      <span class="tw-font-bold">{{ review.date }}</span>
                      <div class="tw-flex tw-items-center tw-gap-2">
                        <svg
                          v-for="n in review.evaluation_value"
                          :key="n"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                            fill="gold"
                          />
                        </svg>
                      </div>
                    </div>
                    <h4>{{ review.person_name }}</h4>
                    <p class="tw-line-clamp-[8] tw-pt-4">{{ review.content }}</p>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </MotionGroup>
        </div>
        <LibrarySliderPagination
          :swiper="swiper"
          variant="v3"
          :can-paginate-back="canPaginateBack"
          :can-paginate-next="canPaginateNext"
        />
      </div>
    </div>

     <div
      v-if="variants.GoogleReviewsV3 === variant"
      class="tw-flex tw-w-full tw-flex-col tw-items-center tw-text-center"
    >
      <h2 v-if="vars.titleText" class="tw-pt-14">{{ vars.titleText }}</h2>
      <div v-if="vars.titleHtml" v-html="vars.titleHtml" class="tw-pt-14"></div>
      <div
        class="tw-relative tw-flex tw-h-full tw-w-full tw-max-w-lg tw-flex-col tw-items-center tw-gap-10 tw-py-14 lg:tw-max-w-full"
      >
        <div class="content-container">
          <MotionGroup
            :preset="vars.animationText ? vars.animationText : 'slideVisibleBottom'"
            :duration="700"
            is="div"
          >
            <div class="swiper-wrapper">
              <Swiper
                :modules="[SwiperPagination]"
                @slideChange="onSlideChange"
                @swiper="onSwiper"
                :slides-per-view="1"
                :space-between="30"
                :loop="true"
                effect="fade"
                :clickable="true"
                :breakpoints="{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  1024: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                  },
                  1336: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                }"
                class="tw-w-full"
              >
                   <SwiperSlide v-for="(review, index) in reviews" :key="index">
                <div
                  class="n-testimonial-card tw-flex tw-h-full tw-min-h-[400px] tw-flex-col tw-items-start tw-gap-3 tw-p-10 tw-text-start"
                  style="border-radius: var(--rounded); border: 2px solid var(--c-primary)"
                >
                  <div class="tw-flex tw-w-full tw-items-start tw-justify-between">
                  
                    <div class="tw-flex tw-items-start tw-gap-2">
                      <!-- Google rozet -->
                      <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.35909 1.28943C5.96112 2.12131 3.89311 3.70024 2.45882 5.79431C1.02454 7.88838 0.299573 10.3872 0.390418 12.9237C0.481264 15.4603 1.38313 17.9008 2.96355 19.8869C4.54396 21.873 6.71962 23.3 9.17096 23.9582C11.1583 24.471 13.2405 24.4935 15.2385 24.0238C17.0484 23.6173 18.7218 22.7476 20.0947 21.5001C21.5236 20.162 22.5608 18.4597 23.0947 16.5763C23.6751 14.5282 23.7783 12.3743 23.3966 10.2801H12.2366V14.9094H18.6997C18.5705 15.6478 18.2937 16.3525 17.8859 16.9814C17.478 17.6102 16.9474 18.1504 16.326 18.5694C15.5367 19.0915 14.6471 19.4428 13.7141 19.6007C12.7784 19.7747 11.8186 19.7747 10.8828 19.6007C9.93444 19.4046 9.03727 19.0132 8.24846 18.4513C6.98124 17.5543 6.02973 16.2799 5.52971 14.8101C5.02124 13.3127 5.02124 11.6893 5.52971 10.1919C5.88564 9.14234 6.47403 8.18669 7.25096 7.39631C8.14007 6.47521 9.26571 5.8168 10.5044 5.49333C11.743 5.16985 13.0469 5.1938 14.2728 5.56256C15.2305 5.85654 16.1063 6.37019 16.8303 7.06256C17.5591 6.33756 18.2866 5.61068 19.0128 4.88193C19.3878 4.49006 19.7966 4.11693 20.166 3.71568C19.0608 2.6872 17.7635 1.88691 16.3485 1.36068C13.7717 0.425038 10.9522 0.399894 8.35909 1.28943Z" fill="white"/>
                        <path d="M8.35875 1.28937C10.9516 0.399224 13.7711 0.423707 16.3481 1.35874C17.7634 1.88855 19.0601 2.69269 20.1637 3.72499C19.7887 4.12624 19.3931 4.50124 19.0106 4.89124C18.2831 5.61749 17.5562 6.34124 16.83 7.06249C16.106 6.37012 15.2302 5.85648 14.2725 5.56249C13.047 5.19244 11.7432 5.16711 10.5042 5.48926C9.26516 5.81141 8.13883 6.46861 7.24875 7.38874C6.47181 8.17912 5.88342 9.13477 5.5275 10.1844L1.64062 7.17499C3.03189 4.41604 5.44078 2.30566 8.35875 1.28937Z" fill="#E33629"/>
                        <path d="M0.607495 10.1561C0.816409 9.12067 1.16325 8.11798 1.63874 7.1748L5.52562 10.1917C5.01715 11.6891 5.01715 13.3124 5.52562 14.8098C4.23062 15.8098 2.93499 16.8148 1.63874 17.8248C0.448402 15.4554 0.0853684 12.7557 0.607495 10.1561Z" fill="#F8BD00"/>
                        <path d="M12.2352 10.2783H23.3952C23.777 12.3726 23.6737 14.5264 23.0933 16.5746C22.5594 18.458 21.5222 20.1602 20.0933 21.4983C18.839 20.5196 17.579 19.5483 16.3246 18.5696C16.9465 18.1501 17.4773 17.6094 17.8852 16.9798C18.2931 16.3503 18.5696 15.6448 18.6983 14.9058H12.2352C12.2333 13.3646 12.2352 11.8214 12.2352 10.2783Z" fill="#587DBD"/>
                        <path d="M1.64062 17.8251C2.93687 16.8251 4.2325 15.8201 5.5275 14.8101C6.02851 16.2804 6.98138 17.5549 8.25 18.4513C9.04127 19.0106 9.94037 19.3988 10.89 19.5913C11.8257 19.7653 12.7855 19.7653 13.7213 19.5913C14.6542 19.4334 15.5439 19.0821 16.3331 18.5601C17.5875 19.5388 18.8475 20.5101 20.1019 21.4888C18.7292 22.737 17.0558 23.6073 15.2456 24.0144C13.2476 24.4841 11.1655 24.4616 9.17813 23.9488C7.60632 23.5291 6.13814 22.7893 4.86563 21.7757C3.51874 20.7063 2.41867 19.3588 1.64062 17.8251Z" fill="#319F43"/>
                      </svg>

                      <!-- Yıldızlar -->
                      <svg
                        v-for="n in review.evaluation_value"
                        :key="n"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                          fill="var(--c-primary)"
                        />
                      </svg>
                    </div>
                  </div>

                  
                  <p
                    class="tw-line-clamp-[8] tw-w-full tw-flex-1 tw-pt-4"
                    style="min-height: 150px;"
                  >
                    {{ review.content }}
                  </p>

                 
                  <h5 class="tw-mt-auto tw-pt-4 tw-text-left">
                    {{ review.person_name }}
                  </h5>
                </div>
              </SwiperSlide>
              </Swiper>
            </div>
          </MotionGroup>
        </div>
        <LibrarySliderPagination
          :swiper="swiper"
          variant="v13"
          :can-paginate-back="canPaginateBack"
          :can-paginate-next="canPaginateNext"
        />
      </div>
    </div>

     <div
      v-if="variants.GoogleReviewsV4 === variant"
      class="tw-flex tw-w-full tw-flex-col tw-items-center tw-text-center"
    >
      <h2 v-if="vars.titleText" class="tw-pt-14">{{ vars.titleText }}</h2>
      <div v-if="vars.titleHtml" v-html="vars.titleHtml" class="tw-pt-14"></div>
      <div
        class="tw-relative tw-flex tw-h-full tw-w-full tw-max-w-lg tw-flex-col tw-items-center tw-gap-10 tw-py-14 lg:tw-max-w-full"
      >
        <div class="content-container">
          <MotionGroup
            :preset="vars.animationText ? vars.animationText : 'slideVisibleBottom'"
            :duration="700"
            is="div"
          >
            <div class="swiper-wrapper">
              <Swiper
                :modules="[SwiperPagination]"
                @slideChange="onSlideChange"
                @swiper="onSwiper"
                :slides-per-view="1"
                :space-between="30"
                :loop="true"
                effect="fade"
                :clickable="true"
                :breakpoints="{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  1024: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                  },
                  1336: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                }"
                class="tw-w-full"
              >
                <SwiperSlide v-for="(review, index) in reviews" :key="index">
                  <div
                    class="n-testimonial-card tw-flex tw-h-full tw-min-h-[400px] tw-flex-col tw-gap-3 tw-p-10 tw-text-start"
                    style="border-radius: var(--rounded); border: 1px solid var(--c-border)"
                  >
                    <div class="tw-flex tw-justify-between">
                  <h5 class="tw-uppercase">{{ review.created_at_formatted || review.created_at }}</h5>

                      <div class="tw-flex tw-items-center tw-gap-2">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" class="tw-mr-2" xmlns="http://www.w3.org/2000/svg">
<path d="M8.36104 1.28894C5.96307 2.12082 3.89506 3.69976 2.46077 5.79382C1.02649 7.88789 0.301526 10.3867 0.392371 12.9233C0.483217 15.4598 1.38508 17.9004 2.9655 19.8864C4.54591 21.8725 6.72158 23.2995 9.17292 23.9577C11.1603 24.4705 13.2424 24.493 15.2404 24.0233C17.0504 23.6168 18.7238 22.7471 20.0967 21.4996C21.5256 20.1615 22.5627 18.4592 23.0967 16.5758C23.677 14.5277 23.7803 12.3738 23.3985 10.2796H12.2385V14.9089H18.7017C18.5725 15.6473 18.2957 16.352 17.8878 16.9809C17.48 17.6098 16.9494 18.1499 16.3279 18.5689C15.5387 19.091 14.649 19.4423 13.716 19.6002C12.7803 19.7742 11.8205 19.7742 10.8848 19.6002C9.9364 19.4041 9.03923 19.0127 8.25042 18.4508C6.9832 17.5538 6.03168 16.2794 5.53167 14.8096C5.02319 13.3122 5.02319 11.6888 5.53167 10.1914C5.88759 9.14185 6.47598 8.1862 7.25292 7.39582C8.14203 6.47472 9.26766 5.81631 10.5063 5.49284C11.745 5.16936 13.0488 5.19331 14.2748 5.56207C15.2325 5.85605 16.1083 6.3697 16.8323 7.06207C17.561 6.33707 18.2885 5.61019 19.0148 4.88144C19.3898 4.48957 19.7985 4.11644 20.1679 3.71519C19.0627 2.68671 17.7654 1.88643 16.3504 1.36019C13.7736 0.42455 10.9541 0.399406 8.36104 1.28894Z" fill="white"/>
<path d="M8.3607 1.28986C10.9536 0.399712 13.7731 0.424195 16.3501 1.35923C17.7654 1.88904 19.062 2.69318 20.1657 3.72548C19.7907 4.12673 19.3951 4.50173 19.0126 4.89173C18.2851 5.61798 17.5582 6.34173 16.832 7.06298C16.1079 6.37061 15.2321 5.85696 14.2745 5.56298C13.0489 5.19293 11.7451 5.16759 10.5061 5.48975C9.26712 5.8119 8.14079 6.4691 7.2507 7.38923C6.47377 8.17961 5.88538 9.13526 5.52945 10.1849L1.64258 7.17548C3.03384 4.41653 5.44273 2.30615 8.3607 1.28986Z" fill="#E33629"/>
<path d="M0.611401 10.1561C0.820316 9.12067 1.16716 8.11798 1.64265 7.1748L5.52953 10.1917C5.02105 11.6891 5.02105 13.3124 5.52953 14.8098C4.23453 15.8098 2.9389 16.8148 1.64265 17.8248C0.452308 15.4554 0.0892746 12.7557 0.611401 10.1561Z" fill="#F8BD00"/>
<path d="M12.2381 10.2783H23.3981C23.7799 12.3726 23.6766 14.5264 23.0963 16.5746C22.5623 18.458 21.5252 20.1602 20.0963 21.4983C18.8419 20.5196 17.5819 19.5483 16.3275 18.5696C16.9494 18.1501 17.4802 17.6094 17.8881 16.9798C18.296 16.3503 18.5726 15.6448 18.7013 14.9058H12.2381C12.2363 13.3646 12.2381 11.8214 12.2381 10.2783Z" fill="#587DBD"/>
<path d="M1.64062 17.8246C2.93687 16.8246 4.2325 15.8196 5.5275 14.8096C6.02851 16.2799 6.98138 17.5544 8.25 18.4508C9.04127 19.0101 9.94037 19.3983 10.89 19.5908C11.8257 19.7648 12.7855 19.7648 13.7213 19.5908C14.6542 19.4329 15.5439 19.0816 16.3331 18.5596C17.5875 19.5383 18.8475 20.5096 20.1019 21.4883C18.7292 22.7366 17.0558 23.6068 15.2456 24.0139C13.2476 24.4836 11.1655 24.4611 9.17813 23.9483C7.60632 23.5286 6.13814 22.7888 4.86563 21.7752C3.51874 20.7059 2.41867 19.3583 1.64062 17.8246Z" fill="#319F43"/>
</svg>

                        <svg
                          v-for="n in review.evaluation_value"
                          :key="n"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                            fill="var(--c-primary)"
                          />
                        </svg>
                      </div>
                    </div>
                    
                    <p class="tw-line-clamp-[8] tw-pt-4">{{ review.content }}</p>
                    <h5 class="tw-mt-3">{{ review.person_name }}</h5>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </MotionGroup>
        </div>
        <LibrarySliderPagination
          :swiper="swiper"
          variant="v3"
          :can-paginate-back="canPaginateBack"
          :can-paginate-next="canPaginateNext"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

type GoogleReview = {
  _id?: string;
  review_id?: string;
  content?: string;
  review_link?: string;
  place_id?: string;
  person_name?: string;
  person_photo?: string;
  evaluation_value?: number;
  created_at?: string;               
  is_hidden?: boolean;
  profiles?: string[];
  platform?: string;
 
  created_at_formatted?: string;   
};

export default defineNuxtComponent({
  name: 'Testimonials',

  mixins: [ComponentMixin],

  data() {
    return {
      swiper: null as any,
      canPaginateBack: true,
      canPaginateNext: true,
      reviews: null as GoogleReview[] | null,
      variants: {
        GoogleReviews: 'GoogleReviews',
        GoogleReviewsV2: 'GoogleReviewsV2',
        GoogleReviewsV3: 'GoogleReviewsV3',
        GoogleReviewsV4: 'GoogleReviewsV4',
      },
    };
  },

  created() {
  
    const parsed = this.parseFormV2(this.vars.googleReviews) as {
      reviews?: GoogleReview[];
    };

    
    this.reviews = (parsed?.reviews ?? []).map((r) => ({
      ...r,
      created_at_formatted: this.formatDateSafe(r?.created_at),
    }));
  },

  computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },
  },

  methods: {
    onSwiper(swiper: any) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      this.canPaginateBack = !isAtStart;
      this.canPaginateNext = !isAtEnd;
    },

   
    formatDateSafe(iso?: string): string | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;

 
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

  },

  mounted() {
    this.onSlideChange();
  },
});
</script>
